import { lightTheme } from "../../theme/theme";
type Theme = typeof lightTheme;

export const ServicesStyles = (theme: Theme) => ({
  root: { background: theme.background, color: theme.text, minHeight: "100%" },
  hero: { maxWidth: 1280, margin: "0 auto", padding: "40px 24px 16px" },
  container: {
    maxWidth: 1280,
    margin: "0 auto",
    padding: "16px 24px 64px",
    boxSizing: "border-box" as const,
  },
});
